export interface IApplicationState {
    isLoading: boolean;
    gamePause: boolean;
    buttonPanelVisibility: boolean;
    layoutMode: string;
    handMode: string;
    resizeWidth: number;
    resizeHeight: number;
    scaleX: number;
    scaleY: number;
    decreaseBet: boolean;
    increaseBet: boolean;
    maxBet: boolean;
    showPaytable: boolean;
    spin: boolean;
    autoPlayLossLimitEnabled: boolean;
    autoPlayLossLimitMandatory: boolean;
    autoPlaySingleWinLimitEnabled: boolean;
    autoPlaySingleWinLimitMandatory: boolean;
    autoPlayWinLimitEnabled: boolean;
    autoPlayWinLimitMandatory: boolean;
    cheatingEnabled: boolean;
    countryCode: boolean;
    currencyCode: string;
    currencyDecimalSeparator: boolean;
    currencyGroupingSeparator: boolean;
    currencyIgnoreDecimals: boolean;
    disableQuickSpin: boolean;
    disableQuickStop: boolean;
    enableAutoPlay: boolean;
    enableRiskCard: boolean;
    enableRiskLadder: boolean;
    historyUrl: boolean;
    homeUrl: boolean;
    languageCode: boolean;
    realityCheckTimePassedInSeconds: boolean;
    realityCheckTimeoutInSeconds: boolean;
    sessionTimeoutInSeconds: boolean;
    showCloseButton: boolean;
    showFullScreenButton: boolean;
    showHelpButton: boolean;
    showRTP: boolean;
    showSettingsControl: boolean;
    showTime: boolean;
    showVolumeControl: boolean;

    balance: number,
    previousbalance: number,
    roundId: number,
    error: string,
    jackpot: number,
    // maxbetvalue: number,
    // minbetvalue: number,
    // defaultbetvalue: number,
    // maxlinevalue: number,
    // minlinevalue: number,
    // defaultlinevalue: number,
    // defaultdenominationsvalue: number,
    // denominations: any,
    // currentbetvalue: number,
    // currentlinevalue: number,
    // currentdenominationsvalue: number,
}

const initialState: IApplicationState = {
    gamePause: false,
    isLoading: false,
    buttonPanelVisibility:false,
    layoutMode: '',
    handMode: 'right',
    resizeWidth: 0,
    resizeHeight: 0,
    scaleX: 1,
    scaleY: 1,
    decreaseBet: false,
    increaseBet: false,
    maxBet: false,
    showPaytable: false,
    spin: false,
    autoPlayLossLimitEnabled: false,
    autoPlayLossLimitMandatory: false,
    autoPlaySingleWinLimitEnabled: false,
    autoPlaySingleWinLimitMandatory: false,
    autoPlayWinLimitEnabled: false,
    autoPlayWinLimitMandatory: false,
    cheatingEnabled: false,
    countryCode: false,
    currencyCode: "",
    currencyDecimalSeparator: false,
    currencyGroupingSeparator: false,
    currencyIgnoreDecimals: false,
    disableQuickSpin: false,
    disableQuickStop: false,
    enableAutoPlay: false,
    enableRiskCard: false,
    enableRiskLadder: false,
    historyUrl: false,
    homeUrl: false,
    languageCode: false,
    realityCheckTimePassedInSeconds: false,
    realityCheckTimeoutInSeconds: false,
    sessionTimeoutInSeconds: false,
    showCloseButton: false,
    showFullScreenButton: false,
    showHelpButton: false,
    showRTP: false,
    showSettingsControl: false,
    showTime: false,
    showVolumeControl: false,

    balance: 0,
    previousbalance: 0,
    roundId: 0,
    error: "",
    jackpot: 0,
    // maxbetvalue: 0,
    // minbetvalue: 0,
    // defaultbetvalue: 0,
    // maxlinevalue: 0,
    // minlinevalue: 0,
    // defaultlinevalue: 0,
    // defaultdenominationsvalue: 0,
    // denominations: [],
    // currentbetvalue: 0,
    // currentlinevalue: 0,
    // currentdenominationsvalue: 0,

};

export enum actionTypes {
    SET_APPLICATION_PAUSE = '@@application/SET_APPLICATION_PAUSE',
    SET_APPLICATION_RESIZE_STATE = '@@application/SET_APPLICATION_RESIZE_STATE',
    SET_APPLICATION_LAYOUT_MODE = '@@application/SET_APPLICATION_LAYOUT_MODE',
    SET_APPLICATION_HAND_MODE = '@@application/SET_APPLICATION_HAND_MODE',
    SET_APPLICATION_BUTTONPANEL_VISIBILITY = '@@application/SET_APPLICATION_BUTTONPANEL_VISIBILITY',
    SET_APPLICATION_LOADING = '@@application/SET_APPLICATION_LOADING',
    GET_APPLICATION_LOADING = '@@application/GET_APPLICATION_LOADING',
    SET_APPLICATION_DECREASE_BET = '@@application/ SET_APPLICATION_DECREASE_BET',
    SET_APPLICATION_INCREASE_BET = '@@application/ SET_APPLICATION_INCREASE_BET',
    SET_APPLICATION_MAX_BET = '@@application/ SET_APPLICATION_MAX_BET',
    SET_APPLICATION_SHOW_PAYTABLE = '@@application/ SET_APPLICATION_SHOW_PAYTABLE',
    SET_APPLICATION_SPIN = '@@application/ SET_APPLICATION_SPIN',
    SET_APPLICATION_AUTOPLAY_LOSS_LIMIT_ENABLED = '@@application/ SET_APPLICATION_AUTOPLAY_LOSS_LIMIT_ENABLED',
    SET_APPLICATION_AUTOPLAY_LOSS_LIMIT_MANDATORY = '@@application/ SET_APPLICATION_AUTOPLAY_LOSS_LIMIT_MANDATORY',
    SET_APPLICATION_AUTOPLAY_SINGLE_WIN_LIMIT_ENABLED = '@@application/ SET_APPLICATION_AUTOPLAY_SINGLE_WIN_LIMIT_ENABLED',
    SET_APPLICATION_AUTOPLAY_SINGLE_WIN_LIMIT_MANDATORY = '@@application/ SET_APPLICATION_AUTOPLAY_SINGLE_WIN_LIMIT_MANDATORY',
    SET_APPLICATION_AUTOPLAY_WIN_LIMIT_ENABLED = '@@application/ SET_APPLICATION_AUTOPLAY_WIN_LIMIT_ENABLED',
    SET_APPLICATION_AUTOPLAY_WIN_LIMIT_MANDATORY = '@@application/ SET_APPLICATION_AUTOPLAY_WIN_LIMIT_MANDATORY',
    SET_APPLICATION_CHEATING_ENABLED = '@@application/ SET_APPLICATION_CHEATING_ENABLED',
    SET_APPLICATION_COUNTRY_CODE = '@@application/ SET_APPLICATION_COUNTRY_CODE',
    SET_APPLICATION_CURRENCY_CODE = '@@application/ SET_APPLICATION_CURRENCY_CODE',
    SET_APPLICATION_CURRENCY_DECIMAL_SEPARATOR = '@@application/ SET_APPLICATION_CURRENCY_DECIMAL_SEPARATOR',
    SET_APPLICATION_CURRENCY_GROUPING_SEPARATOR = '@@application/ SET_APPLICATION_CURRENCY_GROUPING_SEPARATOR',
    SET_APPLICATION_CURRENCY_IGNORE_DECIMALS = '@@application/ SET_APPLICATION_CURRENCY_IGNORE_DECIMALS',
    SET_APPLICATION_DISABLE_QUICK_SPIN = '@@application/ SET_APPLICATION_DISABLE_QUICK_SPIN',
    SET_APPLICATION_DISABLE_QUICK_STOP = '@@application/ SET_APPLICATION_DISABLE_QUICK_STOP',
    SET_APPLICATION_ENABLE_AUTOPLAY = '@@application/ SET_APPLICATION_ENABLE_AUTOPLAY',
    SET_APPLICATION_ENABLE_RISK_CARD = '@@application/ SET_APPLICATION_ENABLE_RISK_CARD',
    SET_APPLICATION_ENABLE_RISK_LADDER = '@@application/ SET_APPLICATION_ENABLE_RISK_LADDER',
    SET_APPLICATION_HISTORY_URL = '@@application/ SET_APPLICATION_HISTORY_URL',
    SET_APPLICATION_HOME_URL = '@@application/ SET_APPLICATION_HOME_URL',
    SET_APPLICATION_LANGUAGE_CODE = '@@application/ SET_APPLICATION_LANGUAGE_CODE',
    SET_APPLICATION_REALITY_CHECK_TIME_PASSED_IN_SECONDS = '@@application/ SET_APPLICATION_REALITY_CHECK_TIME_PASSED_IN_SECONDS',
    SET_APPLICATION_REALITY_CHECK_TIMEOUT_IN_SECONDS = '@@application/ SET_APPLICATION_REALITY_CHECK_TIMEOUT_IN_SECONDS',
    SET_APPLICATION_SESSION_TIMEOUT_IN_SECONDS = '@@application/ SET_APPLICATION_SESSION_TIMEOUT_IN_SECONDS',
    SET_APPLICATION_SHOW_CLOSE_BUTTON = '@@application/ SET_APPLICATION_SHOW_CLOSE_BUTTON',
    SET_APPLICATION_SHOW_FULL_SCREEN_BUTTON = '@@application/ SET_APPLICATION_SHOW_FULL_SCREEN_BUTTON',
    SET_APPLICATION_SHOW_HELP_BUTTON = '@@application/ SET_APPLICATION_SHOW_HELP_BUTTON',
    SET_APPLICATION_SHOW_RTP = '@@application/ SET_APPLICATION_SHOW_RTP',
    SET_APPLICATION_SHOW_SETTINGS_CONTROL = '@@application/ SET_APPLICATION_SHOW_SETTINGS_CONTROL',
    SET_APPLICATION_SHOW_TIME = '@@application/ SET_APPLICATION_SHOW_TIME',
    SET_APPLICATION_SHOW_VOLUME_CONTROL = '@@application/ SET_APPLICATION_SHOW_VOLUME_CONTROL',


    SET_APPLICATION_BALANCE = '@@application/SET_APPLICATION_BALANCE',
    SET_APPLICATION_PREVIOUS_BALANCE = '@@application/SET_APPLICATION_PREVIOUS_BALANCE',
    SET_APPLICATION_ROUND_ID = '@@application/SET_APPLICATION_ROUND_ID',
    SET_APPLICATION_ERROR = '@@application/SET_APPLICATION_ERROR',
    SET_APPLICATION_JACKPOT = '@@application/SET_APPLICATION_JACKPOT',
    // SET_APPLICATION_MAX_BET_VALUE = '@@application/SET_APPLICATION_MAX_BET_VALUE',
    // SET_APPLICATION_MIN_BET_VALUE = '@@application/SET_APPLICATION_MIN_BET_VALUE',
    // SET_APPLICATION_DEFAULT_BET_VALUE = '@@application/SET_APPLICATION_DEFAULT_BET_VALUE',
    //
    // SET_APPLICATION_MAX_LINE_VALUE = '@@application/SET_APPLICATION_MAX_LINE_VALUE',
    // SET_APPLICATION_MIN_LINE_VALUE = '@@application/SET_APPLICATION_MIN_LINE_VALUE',
    // SET_APPLICATION_DEFAULT_LINE_VALUE = '@@application/SET_APPLICATION_DEFAULT_LINE_VALUE',
    //
    // SET_APPLICATION_DEFAULT_DENOMINATION_VALUE = '@@application/SET_APPLICATION_DEFAULT_DENOMINATION_VALUE',
    // SET_APPLICATION_DENOMINATION_LIST = '@@application/SET_APPLICATION_DENOMINATION_LIST',


}

export function reducer(
    state: IApplicationState = initialState,
    action: any,
): IApplicationState {
    const {
        isLoading,
        layout,
        resizewidth,
        resizeheight,
        scalex,
        scaley,
        decreaseBet,
        increaseBet,
        maxBet,
        showPaytable,
        spin,
        autoPlayLossLimitEnabled,
        autoPlayLossLimitMandatory,
        autoPlaySingleWinLimitEnabled,
        autoPlaySingleWinLimitMandatory,
        autoPlayWinLimitEnabled,
        autoPlayWinLimitMandatory,
        cheatingEnabled,
        countryCode,
        currencyCode,
        currencyDecimalSeparator,
        currencyGroupingSeparator,
        currencyIgnoreDecimals,
        disableQuickSpin,
        disableQuickStop,
        enableAutoPlay,
        enableRiskCard,
        enableRiskLadder,
        historyUrl,
        homeUrl,
        languageCode,
        realityCheckTimePassedInSeconds,
        realityCheckTimeoutInSeconds,
        sessionTimeoutInSeconds,
        showCloseButton,
        showFullScreenButton,
        showHelpButton,
        showRTP,
        showSettingsControl,
        showTime,
        showVolumeControl,
        jackpot,
        error,
        roundId,
        previousbalance,
        balance,
        visibility,
        handMode,
        pause

    } = action;
    switch (action.type) {
        case actionTypes.GET_APPLICATION_LOADING:
            return {...state};
        case actionTypes.SET_APPLICATION_LOADING:
            // const {
            //     curebtBalanace
            // } = state;
            // bet >
            return {
                ...state, isLoading: isLoading,
            };
        case actionTypes.SET_APPLICATION_LAYOUT_MODE:
            return {
                ...state, layoutMode: layout,
            };
        case actionTypes.SET_APPLICATION_HAND_MODE:
            return {
                ...state, handMode: handMode,
            };
        case actionTypes.SET_APPLICATION_RESIZE_STATE:
            return {
                ...state,
                resizeWidth: resizewidth,
                resizeHeight: resizeheight,
                scaleX: scalex,
                scaleY: scaley,
            };
        case actionTypes.SET_APPLICATION_DECREASE_BET:
            return {
                ...state, decreaseBet: decreaseBet,
            };
        case actionTypes.SET_APPLICATION_INCREASE_BET:
            return {
                ...state, increaseBet: increaseBet,
            };
        case actionTypes.SET_APPLICATION_MAX_BET:
            return {
                ...state, maxBet: maxBet,
            };
        case actionTypes.SET_APPLICATION_SHOW_PAYTABLE:
            return {
                ...state, showPaytable: showPaytable,
            };
        case actionTypes.SET_APPLICATION_SPIN:
            return {
                ...state, spin: spin,
            };
        case actionTypes.SET_APPLICATION_AUTOPLAY_LOSS_LIMIT_ENABLED:
            return {
                ...state, autoPlayLossLimitEnabled: autoPlayLossLimitEnabled,
            };
        case actionTypes.SET_APPLICATION_AUTOPLAY_LOSS_LIMIT_MANDATORY:
            return {
                ...state, autoPlayLossLimitMandatory: autoPlayLossLimitMandatory,
            };
        case actionTypes.SET_APPLICATION_AUTOPLAY_SINGLE_WIN_LIMIT_ENABLED:
            return {
                ...state, autoPlaySingleWinLimitEnabled: autoPlaySingleWinLimitEnabled,
            };
        case actionTypes.SET_APPLICATION_AUTOPLAY_SINGLE_WIN_LIMIT_MANDATORY:
            return {
                ...state, autoPlaySingleWinLimitMandatory: autoPlaySingleWinLimitMandatory,
            };
        case actionTypes.SET_APPLICATION_AUTOPLAY_WIN_LIMIT_ENABLED:
            return {
                ...state, autoPlayWinLimitEnabled: autoPlayWinLimitEnabled,
            };
        case actionTypes.SET_APPLICATION_AUTOPLAY_WIN_LIMIT_MANDATORY:
            return {
                ...state, autoPlayWinLimitMandatory: autoPlayWinLimitMandatory,
            };
        case actionTypes.SET_APPLICATION_CHEATING_ENABLED:
            return {
                ...state, cheatingEnabled: cheatingEnabled,
            };
        case actionTypes.SET_APPLICATION_COUNTRY_CODE:
            return {
                ...state, countryCode: countryCode,
            };
        case actionTypes.SET_APPLICATION_CURRENCY_CODE:
            return {
                ...state, currencyCode: currencyCode,
            };
        case actionTypes.SET_APPLICATION_CURRENCY_DECIMAL_SEPARATOR:
            return {
                ...state, currencyDecimalSeparator: currencyDecimalSeparator,
            };
        case actionTypes.SET_APPLICATION_CURRENCY_GROUPING_SEPARATOR:
            return {
                ...state, currencyGroupingSeparator: currencyGroupingSeparator,
            };
        case actionTypes.SET_APPLICATION_CURRENCY_IGNORE_DECIMALS:
            return {
                ...state, currencyIgnoreDecimals: currencyIgnoreDecimals,
            };
        case actionTypes.SET_APPLICATION_DISABLE_QUICK_SPIN:
            return {
                ...state, disableQuickSpin: disableQuickSpin,
            };
        case actionTypes.SET_APPLICATION_DISABLE_QUICK_STOP:
            return {
                ...state, disableQuickStop: disableQuickStop,
            };
        case actionTypes.SET_APPLICATION_ENABLE_AUTOPLAY:
            return {
                ...state, enableAutoPlay: enableAutoPlay,
            };
        case actionTypes.SET_APPLICATION_ENABLE_RISK_CARD:
            return {
                ...state, enableRiskCard: enableRiskCard,
            };
        case actionTypes.SET_APPLICATION_ENABLE_RISK_LADDER:
            return {
                ...state, enableRiskLadder: enableRiskLadder,
            };
        case actionTypes.SET_APPLICATION_HISTORY_URL:
            return {
                ...state, historyUrl: historyUrl,
            };
        case actionTypes.SET_APPLICATION_HOME_URL:
            return {
                ...state, homeUrl: homeUrl,
            };
        case actionTypes.SET_APPLICATION_BUTTONPANEL_VISIBILITY:
            return {
                ...state, buttonPanelVisibility: visibility,
            };
        case actionTypes.SET_APPLICATION_LANGUAGE_CODE:
            return {
                ...state, languageCode: languageCode,
            };
        case actionTypes.SET_APPLICATION_REALITY_CHECK_TIME_PASSED_IN_SECONDS:
            return {
                ...state, realityCheckTimePassedInSeconds: realityCheckTimePassedInSeconds,
            };
        case actionTypes.SET_APPLICATION_REALITY_CHECK_TIMEOUT_IN_SECONDS:
            return {
                ...state, realityCheckTimeoutInSeconds: realityCheckTimeoutInSeconds,
            };
        case actionTypes.SET_APPLICATION_SESSION_TIMEOUT_IN_SECONDS:
            return {
                ...state, sessionTimeoutInSeconds: sessionTimeoutInSeconds,
            };
        case actionTypes.SET_APPLICATION_SHOW_CLOSE_BUTTON:
            return {
                ...state, showCloseButton: showCloseButton,
            };
        case actionTypes.SET_APPLICATION_SHOW_FULL_SCREEN_BUTTON:
            return {
                ...state, showFullScreenButton: showFullScreenButton,
            };
        case actionTypes.SET_APPLICATION_SHOW_HELP_BUTTON:
            return {
                ...state, showHelpButton: showHelpButton,
            };
        case actionTypes.SET_APPLICATION_SHOW_RTP:
             
            return {
                ...state, showRTP: showRTP,
            };
        case actionTypes.SET_APPLICATION_SHOW_SETTINGS_CONTROL:
            return {
                ...state, showSettingsControl: showSettingsControl,
            };
        case actionTypes.SET_APPLICATION_SHOW_TIME:
            return {
                ...state, showTime: showTime,
            };
        case actionTypes.SET_APPLICATION_SHOW_VOLUME_CONTROL:
            return {
                ...state, showVolumeControl: showVolumeControl,
            };


        case actionTypes.SET_APPLICATION_BALANCE:
            return {
                ...state, balance: balance,
            };
        case actionTypes.SET_APPLICATION_PREVIOUS_BALANCE:
            return {
                ...state, previousbalance: previousbalance,
            };
        case actionTypes.SET_APPLICATION_ROUND_ID:
            return {
                ...state, roundId: roundId,
            };
        case actionTypes.SET_APPLICATION_ERROR:
            return {
                ...state, error: error,
            };
        case actionTypes.SET_APPLICATION_JACKPOT:
            return {
                ...state, jackpot: jackpot,
            };
        case actionTypes.SET_APPLICATION_PAUSE:
            return {
                ...state, gamePause: pause,
            };
        // case actionTypes.SET_APPLICATION_MIN_BET_VALUE:
        //     return {
        //         ...state, minbetvalue: minbetvalue,
        //     };
        // case actionTypes.SET_APPLICATION_DEFAULT_BET_VALUE:
        //     return {
        //         ...state,currentbetvalue: defaultbetvalue,defaultbetvalue: defaultbetvalue,
        //     };
        // case actionTypes.SET_APPLICATION_MAX_LINE_VALUE:
        //     return {
        //         ...state, maxlinevalue: maxlinevalue,
        //     };
        // case actionTypes.SET_APPLICATION_MIN_LINE_VALUE:
        //     return {
        //         ...state, minlinevalue: minlinevalue,
        //     };
        // case actionTypes.SET_APPLICATION_DEFAULT_LINE_VALUE:
        //     return {
        //         ...state,currentlinevalue:defaultlinevalue, defaultlinevalue: defaultlinevalue,
        //     };
        // case actionTypes.SET_APPLICATION_DEFAULT_DENOMINATION_VALUE:
        //     return {
        //         ...state,currentdenominationsvalue:defaultdenominationvalue, defaultdenominationsvalue: defaultdenominationvalue,
        //     };
        // case actionTypes.SET_APPLICATION_DENOMINATION_LIST:
        //     return {
        //         ...state, denominations: denominationlist,
        //     };
        default:
            return state;
    }
}

export const actions = {

    // balance: number,
    // previousbalance: number,
    // roundId: number,
    // error: string,
    // jackpot: number,
    // maxbetvalue: number,
    // minbetvalue: number,
    // defaultbetvalue: number,
    // maxlinevalue: number,
    // minlinevalue: number,
    // defaultlinevalue: number,
    // defaultdenominationsvalue: number,
    // denominations: any,

    setApplicationPause: (pause: boolean): any => ({
        type: actionTypes.SET_APPLICATION_PAUSE,
        pause
    }),
    setApplicationBalance: (balance: number): any => ({
        type: actionTypes.SET_APPLICATION_BALANCE,
        balance
    }),
    setApplicationPreviousBalance: (previousbalance: number): any => ({
        type: actionTypes.SET_APPLICATION_PREVIOUS_BALANCE,
        previousbalance
    }),
    setApplicationRoundId: (roundId: number): any => ({
        type: actionTypes.SET_APPLICATION_ROUND_ID,
        roundId
    }),
    setApplicationError: (error: string): any => ({
        type: actionTypes.SET_APPLICATION_ERROR,
        error
    }),
    setApplicationJackpot: (jackpot: number): any => ({
        type: actionTypes.SET_APPLICATION_JACKPOT,
        jackpot
    }),
    // setApplicationMaxBetValue: (maxbetvalue: number): any => ({
    //     type: actionTypes.SET_APPLICATION_MAX_BET_VALUE,
    //     maxbetvalue
    // }),
    // setApplicationMinBetValue: (minbetvalue: number): any => ({
    //     type: actionTypes.SET_APPLICATION_MIN_BET_VALUE,
    //     minbetvalue
    // }),
    // setApplicationDefaultBetValue: (defaultbetvalue: number): any => ({
    //     type: actionTypes.SET_APPLICATION_DEFAULT_BET_VALUE,
    //     defaultbetvalue
    // }),
    // setApplicationMaxLineValue: (maxlinevalue: number): any => ({
    //     type: actionTypes.SET_APPLICATION_MAX_LINE_VALUE,
    //     maxlinevalue
    // }),
    // setApplicationMinLineValue: (minlinevalue: number): any => ({
    //     type: actionTypes.SET_APPLICATION_MIN_LINE_VALUE,
    //     minlinevalue
    // }),
    // setApplicationDefaultLineValue: (defaultlinevalue: number): any => ({
    //     type: actionTypes.SET_APPLICATION_DEFAULT_LINE_VALUE,
    //     defaultlinevalue
    // }),
    // setApplicationDefaultDenominationValue: (defaultdenominationvalue: number): any => ({
    //     type: actionTypes.SET_APPLICATION_DEFAULT_DENOMINATION_VALUE,
    //     defaultdenominationvalue
    // }),
    // setApplicationDenominationList: (denominationlist: any): any => ({
    //     type: actionTypes.SET_APPLICATION_DENOMINATION_LIST,
    //     denominationlist
    // }),


    setApplicationLayoutMode: (layout: string): any => ({type: actionTypes.SET_APPLICATION_LAYOUT_MODE, layout}),
    setApplicationHandMode: (handMode: string): any => ({type: actionTypes.SET_APPLICATION_HAND_MODE, handMode}),
    setApplicationLoading: (isLoading: boolean): any => ({type: actionTypes.SET_APPLICATION_LOADING, isLoading}),
    setApplicationDecreaseBet: (decreaseBet: boolean): any => ({
        type: actionTypes.SET_APPLICATION_DECREASE_BET,
        decreaseBet
    }),
    setApplicationIncreaseBet: (increaseBet: boolean): any => ({
        type: actionTypes.SET_APPLICATION_INCREASE_BET,
        increaseBet
    }),
    setApplicationMaxBet: (maxBet: boolean): any => ({type: actionTypes.SET_APPLICATION_MAX_BET, maxBet}),
    setApplicationShowPaytable: (showPaytable: boolean): any => ({
        type: actionTypes.SET_APPLICATION_SHOW_PAYTABLE,
        showPaytable
    }),
    setApplicationSpin: (spin: boolean): any => ({type: actionTypes.SET_APPLICATION_SPIN, spin}),
    setApplicationAutoPlayLossLimitEnabled: (autoPlayLossLimitEnabled: boolean): any => ({
        type: actionTypes.SET_APPLICATION_AUTOPLAY_LOSS_LIMIT_ENABLED,
        autoPlayLossLimitEnabled
    }),
    setApplicationAutoPlayLossLimitMandatory: (autoPlayLossLimitMandatory: boolean): any => ({
        type: actionTypes.SET_APPLICATION_AUTOPLAY_LOSS_LIMIT_MANDATORY,
        autoPlayLossLimitMandatory
    }),
    setApplicationAutoPlaySingleWinLimitEnabled: (autoPlaySingleWinLimitEnabled: boolean): any => ({
        type: actionTypes.SET_APPLICATION_AUTOPLAY_SINGLE_WIN_LIMIT_ENABLED,
        autoPlaySingleWinLimitEnabled
    }),
    setApplicationAutoPlaySingleWinLimitMandatory: (autoPlaySingleWinLimitMandatory: boolean): any => ({
        type: actionTypes.SET_APPLICATION_AUTOPLAY_SINGLE_WIN_LIMIT_MANDATORY,
        autoPlaySingleWinLimitMandatory
    }),
    setApplicationAutoPlayWinLimitEnabled: (autoPlayWinLimitEnabled: boolean): any => ({
        type: actionTypes.SET_APPLICATION_AUTOPLAY_WIN_LIMIT_ENABLED,
        autoPlayWinLimitEnabled
    }),
    setApplicationAutoPlayWinLimitMandatory: (autoPlayWinLimitMandatory: boolean): any => ({
        type: actionTypes.SET_APPLICATION_AUTOPLAY_WIN_LIMIT_MANDATORY,
        autoPlayWinLimitMandatory
    }),
    setApplicationCheatingEnabled: (cheatingEnabled: boolean): any => ({
        type: actionTypes.SET_APPLICATION_CHEATING_ENABLED,
        cheatingEnabled
    }),
    setApplicationCountryCode: (countryCode: boolean): any => ({
        type: actionTypes.SET_APPLICATION_COUNTRY_CODE,
        countryCode
    }),
    setApplicationCurrencyCode: (currencyCode: boolean): any => ({
        type: actionTypes.SET_APPLICATION_CURRENCY_CODE,
        currencyCode
    }),
    setApplicationCurrencyDecimalSeparator: (currencyDecimalSeparator: boolean): any => ({
        type: actionTypes.SET_APPLICATION_CURRENCY_DECIMAL_SEPARATOR,
        currencyDecimalSeparator
    }),
    setApplicationCurrencyGroupingSeparator: (currencyGroupingSeparator: boolean): any => ({
        type: actionTypes.SET_APPLICATION_CURRENCY_GROUPING_SEPARATOR,
        currencyGroupingSeparator
    }),
    setApplicationCurrencyIgnoreDecimals: (currencyIgnoreDecimals: boolean): any => ({
        type: actionTypes.SET_APPLICATION_CURRENCY_IGNORE_DECIMALS,
        currencyIgnoreDecimals
    }),
    setApplicationDisableQuickSpin: (disableQuickSpin: boolean): any => ({
        type: actionTypes.SET_APPLICATION_DISABLE_QUICK_SPIN,
        disableQuickSpin
    }),
    setApplicationDisableQuickStop: (disableQuickStop: boolean): any => ({
        type: actionTypes.SET_APPLICATION_DISABLE_QUICK_STOP,
        disableQuickStop
    }),
    setApplicationEnableAutoPlay: (enableAutoPlay: boolean): any => ({
        type: actionTypes.SET_APPLICATION_ENABLE_AUTOPLAY,
        enableAutoPlay
    }),
    setApplicationEnableRiskCard: (enableRiskCard: boolean): any => ({
        type: actionTypes.SET_APPLICATION_ENABLE_RISK_CARD,
        enableRiskCard
    }),
    setApplicationHistoryUrl: (historyUrl: boolean): any => ({
        type: actionTypes.SET_APPLICATION_HISTORY_URL,
        historyUrl
    }),
    setApplicationHomeUrl: (homeUrl: boolean): any => ({type: actionTypes.SET_APPLICATION_HOME_URL, homeUrl}),
    setApplicationButtonpanelVisibility: (visibility: boolean): any => ({
        type: actionTypes.SET_APPLICATION_BUTTONPANEL_VISIBILITY,
        visibility
    }),
    setApplicationLanguageCode: (languageCode: boolean): any => ({
        type: actionTypes.SET_APPLICATION_LANGUAGE_CODE,
        languageCode
    }),
    setApplicationRealityCheckTimePassedInSeconds: (realityCheckTimePassedInSeconds: boolean): any => ({
        type: actionTypes.SET_APPLICATION_REALITY_CHECK_TIME_PASSED_IN_SECONDS,
        realityCheckTimePassedInSeconds
    }),
    setApplicationRealityCheckTimeoutInSeconds: (realityCheckTimeoutInSeconds: boolean): any => ({
        type: actionTypes.SET_APPLICATION_REALITY_CHECK_TIMEOUT_IN_SECONDS,
        realityCheckTimeoutInSeconds
    }),
    setApplicationSessionTimeoutInSeconds: (sessionTimeoutInSeconds: boolean): any => ({
        type: actionTypes.SET_APPLICATION_SESSION_TIMEOUT_IN_SECONDS,
        sessionTimeoutInSeconds
    }),
    setApplicationShowCloseButton: (showCloseButton: boolean): any => ({
        type: actionTypes.SET_APPLICATION_SHOW_CLOSE_BUTTON,
        showCloseButton
    }),
    setApplicationShowFullScreenButton: (showFullScreenButton: boolean): any => ({
        type: actionTypes.SET_APPLICATION_SHOW_FULL_SCREEN_BUTTON,
        showFullScreenButton
    }),
    setApplicationShowHelpButton: (showHelpButton: boolean): any => ({
        type: actionTypes.SET_APPLICATION_SHOW_HELP_BUTTON,
        showHelpButton
    }),
    setApplicationShowRTP: (showRTP: boolean): any => ({type: actionTypes.SET_APPLICATION_SHOW_RTP, showRTP}),
    setApplicationShowSettingsControl: (showSettingsControl: boolean): any => ({
        type: actionTypes.SET_APPLICATION_SHOW_SETTINGS_CONTROL,
        showSettingsControl
    }),
    setApplicationShowTime: (showTime: boolean): any => ({type: actionTypes.SET_APPLICATION_SHOW_TIME, showTime}),
    setApplicationShowVolumeControl: (showVolumeControl: boolean): any => ({
        type: actionTypes.SET_APPLICATION_SHOW_VOLUME_CONTROL,
        showVolumeControl
    }),


    setApplicationResizeState: (resizewidth: number, resizeheight: number, scalex: number, scaley: number): any => ({
        type: actionTypes.SET_APPLICATION_RESIZE_STATE,
        resizewidth,
        resizeheight,
        scalex,
        scaley
    }),
    getApplicationLoading: (): any => ({type: actionTypes.GET_APPLICATION_LOADING}),
};
